import { render, staticRenderFns } from "./SectionDetails.vue?vue&type=template&id=0d3228c4"
import script from "./SectionDetails.vue?vue&type=script&lang=js"
export * from "./SectionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports